import React from "react";
import { Body, Headline } from "../brand";
import { IconBook } from "../brand/icons";

const Newsletter1 = () => {
  return (
    <section className="w-full bg-surface-white pb-10 pt-14">
      <div className="mx-auto w-full max-w-7xl px-5 text-center sm:px-6 sm:text-left md:px-10">
        <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-cloud-mist px-3.5 py-1.5 text-label-sm font-semibold tracking-wide text-spectrum-blue">
          <IconBook size={16} />
          Community Publication
        </span>
        <Headline bold="Newsletter" as="h1" className="mb-3 !text-center sm:!text-left" />
        <Body className="mx-auto !max-w-2xl !text-body-lg text-muted !text-center sm:mx-0 sm:!text-left">
          Stories, insights, and community voices delivered monthly to your village.
        </Body>
      </div>
    </section>
  );
};

export default Newsletter1;
